export default {
    closeMenu(state, payload) {
        state.menu.drawer = payload
    },
    openLoader(state, payload) {
        state.loader = payload
    },
    userData(state, payload) {
        state.userData = payload
        try {
            sessionStorage.setItem("userData", JSON.stringify(payload))
            localStorage.setItem("userData", JSON.stringify(payload))
        } catch (e) { /* ignore */ }
    },
    userPermissions(state, payload) {
        state.userPermissions = payload
        try {
            sessionStorage.setItem("userPermissions", JSON.stringify(payload))
            localStorage.setItem("userPermissions", JSON.stringify(payload))
        } catch (e) { /* ignore */ }
    },
}